(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norla-collection-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('norla-collection-slider')) {
    class NorlaCollectionSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.delay = parseInt(this.dataset.autoplay, 10) * 1000 || 0;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.delay = 0;

        this.querySelectorAll('[data-down]').forEach((link) =>
          link.addEventListener('click', (e) => {
            const grid = document.getElementById('ncs-grid');
            if (!grid) return;
            e.preventDefault();
            grid.scrollIntoView({ behavior: 'smooth' });
          })
        );

        this.setActive(0);
        if (this.slides.length < 2) return;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1, true); }
        });

        // Swipes on touch devices move the track natively; keep the state in sync.
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setActive(this.slides.indexOf(entry.target));
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));

        this.addEventListener('pointerdown', () => this.stop(), { passive: true });
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('pointerenter', () => this.pause());
        this.addEventListener('pointerleave', () => this.play());
        this.play();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        clearTimeout(this.timer);
      }

      go(i, userInitiated) {
        const count = this.slides.length;
        const target = (i + count) % count;
        this.track.scrollTo({ left: this.slides[target].offsetLeft - this.slides[0].offsetLeft });
        this.setActive(target);
        if (userInitiated) this.stop();
      }

      setActive(i) {
        if (i < 0 || !this.slides[i]) return;
        if (i === this.index && this.slides[i].classList.contains('is-active') && this.timer) return;
        this.index = i;
        this.slides.forEach((slide, n) => slide.classList.toggle('is-active', n === i));
        // The nav sits under the text column, so it follows the photo side.
        this.dataset.photo = this.slides[i].classList.contains('ncs__slide--photo-right') ? 'right' : 'left';
        this.dots.forEach((dot, n) => {
          if (n === i) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (this.hasAttribute('data-playing')) this.schedule();
      }

      play() {
        if (!this.delay || this.stopped) return;
        this.setAttribute('data-playing', '');
        this.schedule();
      }

      pause() {
        this.removeAttribute('data-playing');
        clearTimeout(this.timer);
        this.timer = null;
      }

      schedule() {
        clearTimeout(this.timer);
        // The explainer slide carries more text, so it stays up longer.
        const factor = parseFloat(this.slides[this.index].dataset.delayFactor) || 1;
        const duration = this.delay * factor;
        this.style.setProperty('--ncs-duration', duration / 1000 + 's');
        const bar = this.dots[this.index]?.querySelector('span');
        if (bar) { bar.style.display = 'none'; void bar.offsetWidth; bar.style.display = ''; }
        this.timer = setTimeout(() => this.go(this.index + 1), duration);
      }

      stop() {
        this.stopped = true;
        this.pause();
      }
    }
    customElements.define('norla-collection-slider', NorlaCollectionSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norla-expectations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__olxRevealInit) return;
    window.__olxRevealInit = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function run() {
      var els = document.querySelectorAll('.olx-reveal:not(.is-visible)');
      if (reduce || !('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norla-formula-facts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__olxRevealInit) return;
    window.__olxRevealInit = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function run() {
      var els = document.querySelectorAll('.olx-reveal:not(.is-visible)');
      if (reduce || !('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norla-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__olxRevealInit) return;
    window.__olxRevealInit = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function run() {
      var els = document.querySelectorAll('.olx-reveal:not(.is-visible)');
      if (reduce || !('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norla-routine-builder"] && !Shopify.designMode) return;
  try {
    
  // Adds every step of the routine in one request. The theme's own cart
  // components are ES modules, so instead of importing CartAddEvent this
  // dispatches the same 'cart:update' event shape they already listen for —
  // without a sections payload, which makes them refetch their own markup.
  class NorlaRoutine extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[ref="addButton"]');
      this.error = this.querySelector('[ref="error"]');
      if (!this.button || this.button.disabled) return;

      this.button.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
    }

    handleClick = async () => {
      const ids = this.dataset.bundleVariantId
        ? [this.dataset.bundleVariantId]
        : Array.from(this.querySelectorAll('[data-variant-id]'))
            .map((el) => el.dataset.variantId)
            .filter(Boolean);

      if (ids.length === 0) return;

      this.error?.classList.add('hidden');
      this.button.disabled = true;
      this.button.textContent = this.button.dataset.labelBusy;

      try {
        const response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) }),
        });

        if (!response.ok) throw new Error(`Cart responded ${response.status}`);
        await response.json();

        // add.js returns only the lines it added, so pull the whole cart —
        // the drawer reads item_count off this to announce the new total.
        const cart = await fetch(`${Theme.routes.cart_url}.js`).then((r) => r.json());

        this.button.textContent = this.button.dataset.labelDone;

        const event = new Event('cart:update', { bubbles: true });
        event.detail = {
          resource: cart,
          sourceId: this.id || 'norla-routine',
          data: { source: 'norla-routine-builder' },
        };
        document.dispatchEvent(event);

        setTimeout(() => {
          this.button.textContent = this.button.dataset.labelIdle;
          this.button.disabled = false;
        }, 2500);
      } catch (error) {
        console.error(error);
        this.error?.classList.remove('hidden');
        this.button.textContent = this.button.dataset.labelIdle;
        this.button.disabled = false;
      }
    };
  }

  if (!customElements.get('norla-routine')) {
    customElements.define('norla-routine', NorlaRoutine);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oriluxe-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBA(root) {
      var viewer = root.matches('[data-olx-ba]') ? root : root.querySelector('[data-olx-ba]');
      if (!viewer || viewer.__olxInit) return;
      viewer.__olxInit = true;
      var before = viewer.querySelector('[data-olx-ba-before]');
      var beforeImg = before ? before.querySelector('img, svg') : null;
      var handle = viewer.querySelector('[data-olx-ba-handle]');
      var range = viewer.querySelector('[data-olx-ba-range]');
      function sizeImg() {
        if (beforeImg) beforeImg.style.setProperty('width', viewer.clientWidth + 'px');
      }
      function set(pct) {
        pct = Math.max(0, Math.min(100, pct));
        before.style.width = pct + '%';
        handle.style.left = pct + '%';
      }
      range.addEventListener('input', function () { set(parseFloat(range.value)); });
      window.addEventListener('resize', sizeImg);
      sizeImg();
      set(parseFloat(range.value));
    }
    function runAll() { document.querySelectorAll('[data-olx-ba]').forEach(initBA); }
    if (document.readyState !== 'loading') runAll();
    else document.addEventListener('DOMContentLoaded', runAll);
    document.addEventListener('shopify:section:load', function (e) { initBA(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oriluxe-product-feature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__olxRevealInit2) return;
    window.__olxRevealInit2 = true;
    function run() {
      var els = document.querySelectorAll('.olx-feat .olx-reveal:not(.is-visible)');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
      }, { threshold: 0.15 });
      els.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oriluxe-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initQuiz(root) {
      var section = root.matches('[data-olx-quiz]') ? root : root.querySelector('[data-olx-quiz]');
      if (!section || section.__olxQuiz) return;
      section.__olxQuiz = true;

      var steps = Array.prototype.slice.call(section.querySelectorAll('[data-olx-quiz-step]'));
      var results = Array.prototype.slice.call(section.querySelectorAll('[data-olx-quiz-result]'));
      var progressWrap = section.querySelector('[data-olx-quiz-progress]');
      var progressFill = section.querySelector('[data-olx-quiz-progress-fill]');
      var progressCurrent = section.querySelector('[data-olx-quiz-progress-current]');
      var totalSteps = steps.length;
      var selectedTagsByStep = new Array(totalSteps).fill(null);
      var selectedLabelsByStep = new Array(totalSteps).fill(null);
      var transitioning = false;

      function updateProgress(index) {
        if (progressFill) progressFill.style.width = (totalSteps ? (index / totalSteps) * 100 : 0) + '%';
        if (progressCurrent) progressCurrent.textContent = Math.min(index + 1, totalSteps || 1);
      }

      function showStep(index) {
        steps.forEach(function (stepEl, i) {
          stepEl.hidden = i !== index;
          var backBtn = stepEl.querySelector('[data-olx-quiz-back]');
          if (backBtn) backBtn.hidden = i === 0;
          if (i === index) {
            stepEl.querySelectorAll('[data-olx-quiz-answer]').forEach(function (b) { b.disabled = false; });
          }
        });
        updateProgress(index);
      }

      function pickResult() {
        var selectedTags = selectedTagsByStep.filter(Boolean);
        var best = null;
        var bestScore = -1;
        var fallback = null;
        results.forEach(function (r) {
          if (!fallback && r.getAttribute('data-default') === 'true') fallback = r;
          var tags = (r.getAttribute('data-tags') || '')
            .split(',')
            .map(function (t) { return t.trim().toLowerCase(); })
            .filter(Boolean);
          if (!tags.length) return;
          var matched = 0;
          tags.forEach(function (t) { if (selectedTags.indexOf(t) !== -1) matched += 1; });
          var score = matched / tags.length;
          if (score > bestScore) {
            bestScore = score;
            best = r;
          }
        });
        if (bestScore <= 0 && fallback) return fallback;
        return best || fallback;
      }

      function showResult() {
        var match = pickResult();
        if (!match) return;
        var basisLabels = selectedLabelsByStep.filter(Boolean);
        results.forEach(function (r) {
          r.hidden = r !== match;
          var basisEl = r.querySelector('[data-olx-quiz-result-basis]');
          if (basisEl) basisEl.hidden = true;
        });
        steps.forEach(function (s) { s.hidden = true; });
        if (progressWrap) progressWrap.hidden = true;
        var basisEl = match.querySelector('[data-olx-quiz-result-basis]');
        var basisTextEl = match.querySelector('[data-olx-quiz-result-basis-text]');
        if (basisEl && basisTextEl && basisLabels.length) {
          basisTextEl.textContent = basisLabels.join(', ');
          basisEl.hidden = false;
        }
        match.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      steps.forEach(function (stepEl, index) {
        var answers = stepEl.querySelectorAll('[data-olx-quiz-answer]');
        var backBtn = stepEl.querySelector('[data-olx-quiz-back]');
        if (backBtn) {
          backBtn.addEventListener('click', function () {
            if (transitioning) return;
            showStep(index - 1);
          });
        }
        answers.forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (transitioning) return;
            transitioning = true;
            answers.forEach(function (b) { b.classList.remove('is-active'); b.disabled = true; });
            btn.classList.add('is-active');
            var tag = (btn.getAttribute('data-tag') || '').trim().toLowerCase();
            var labelEl = btn.querySelector('.olx-quiz__opt-label');
            selectedTagsByStep[index] = tag || null;
            selectedLabelsByStep[index] = labelEl ? labelEl.textContent.trim() : null;
            window.setTimeout(function () {
              transitioning = false;
              if (index + 1 < steps.length) showStep(index + 1); else showResult();
            }, 260);
          });
        });
      });

      var restartButtons = section.querySelectorAll('[data-olx-quiz-restart]');
      restartButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectedTagsByStep = new Array(steps.length).fill(null);
          selectedLabelsByStep = new Array(steps.length).fill(null);
          transitioning = false;
          steps.forEach(function (stepEl) {
            stepEl.querySelectorAll('[data-olx-quiz-answer]').forEach(function (b) { b.classList.remove('is-active'); b.disabled = false; });
          });
          results.forEach(function (r) {
            r.hidden = true;
            var basisEl = r.querySelector('[data-olx-quiz-result-basis]');
            if (basisEl) basisEl.hidden = true;
          });
          if (progressWrap) progressWrap.hidden = false;
          showStep(0);
          section.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });

      var copyButtons = section.querySelectorAll('[data-olx-quiz-copy-code]');
      copyButtons.forEach(function (btn) {
        var code = btn.getAttribute('data-code') || '';
        var labelEl = btn.querySelector('[data-olx-quiz-copy-label]');
        var defaultLabel = btn.getAttribute('data-copy-label') || (labelEl ? labelEl.textContent : '');
        var copiedLabel = btn.getAttribute('data-copied-label') || defaultLabel;
        var resetTimer = null;
        btn.addEventListener('click', function () {
          function showCopied() {
            if (labelEl) labelEl.textContent = copiedLabel;
            btn.classList.add('is-copied');
            window.clearTimeout(resetTimer);
            resetTimer = window.setTimeout(function () {
              if (labelEl) labelEl.textContent = defaultLabel;
              btn.classList.remove('is-copied');
            }, 1800);
          }
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(showCopied, showCopied);
          } else {
            var temp = document.createElement('textarea');
            temp.value = code;
            temp.style.position = 'fixed';
            temp.style.opacity = '0';
            document.body.appendChild(temp);
            temp.select();
            try { document.execCommand('copy'); } catch (e) {}
            document.body.removeChild(temp);
            showCopied();
          }
        });
      });

      showStep(0);
    }
    function runAll() { document.querySelectorAll('[data-olx-quiz]').forEach(initQuiz); }
    if (document.readyState !== 'loading') runAll(); else document.addEventListener('DOMContentLoaded', runAll);
    document.addEventListener('shopify:section:load', function (e) { initQuiz(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oriluxe-science"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__olxRevealInit) return;
    window.__olxRevealInit = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function run() {
      var els = document.querySelectorAll('.olx-reveal:not(.is-visible)');
      if (reduce || !('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oriluxe-video-3d"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initV3D(section) {
      var stage = section.querySelector('[data-olx-v3d-stage]');
      var card = section.querySelector('[data-olx-v3d-card]');
      var video = section.querySelector('.olx-v3d__video');
      if (!stage || !card || card.__olx) return;
      card.__olx = true;

      if (video) {
        var rate = parseFloat(video.getAttribute('data-olx-rate')) || 1;
        var applyRate = function () { try { video.playbackRate = rate; } catch (e) {} };
        video.addEventListener('loadedmetadata', applyRate);
        video.addEventListener('play', applyRate);
        var play = function () { applyRate(); var p = video.play(); if (p && p.catch) p.catch(function () {}); };
        // Lazy: only load + play the video when it scrolls into view; pause when out (perf).
        if ('IntersectionObserver' in window) {
          var vio = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) { play(); } else { try { video.pause(); } catch (err) {} }
            });
          }, { threshold: 0.25 });
          vio.observe(video);
        } else {
          play();
        }
      }

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (reduce || !canHover) return; // no tilt on touch devices — keeps scrolling smooth

      var max = parseFloat(getComputedStyle(section).getPropertyValue('--olx-tilt')) || 10;
      var targetX = 0, targetY = 0, curX = 0, curY = 0, raf = null, hovering = false;

      function loop() {
        curX += (targetX - curX) * 0.12;
        curY += (targetY - curY) * 0.12;
        card.style.transform = 'rotateX(' + curY + 'deg) rotateY(' + curX + 'deg)';
        if (Math.abs(targetX - curX) > 0.05 || Math.abs(targetY - curY) > 0.05 || hovering) {
          raf = requestAnimationFrame(loop);
        } else { raf = null; }
      }
      function kick() { if (!raf) raf = requestAnimationFrame(loop); }

      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        targetX = px * max; targetY = -py * max;
        card.style.animationPlayState = 'paused';
        hovering = true; kick();
      });
      stage.addEventListener('pointerleave', function () {
        targetX = 0; targetY = 0; hovering = false;
        card.style.animationPlayState = '';
        kick();
      });
    }
    function runAll() { document.querySelectorAll('[data-olx-v3d]').forEach(initV3D); }
    if (document.readyState !== 'loading') runAll();
    else document.addEventListener('DOMContentLoaded', runAll);
    document.addEventListener('shopify:section:load', function (e) { initV3D(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
